import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function AuthWrapper({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('d4uToken');
    const userData = localStorage.getItem('userData');
    const roleData = localStorage.getItem('roleData');

    const publicPaths = new Set([
      '/',
      '/admin',
      '/agentLogin',
      '/subAgentLogin',
      '/passwordResetAdmin',
      '/reset-password',
      '/ambulance-company/register',
      '/terms',
      '/passenger/login'
    ]);

    // Passenger portal should not be affected by admin AuthWrapper.
    // It has its own login/token and route gating.
    if (location.pathname.startsWith('/passenger')) {
      return;
    }

    const isResetPasswordPath = location.pathname === '/reset-password';

    if (token && userData && roleData) {
      // User is authenticated
      const userType = localStorage.getItem('userType');

      // Allow staying on reset-password even if authenticated
      if (!isResetPasswordPath && publicPaths.has(location.pathname)) {
        // Redirect authenticated users away from other auth/public entry points
        if (userType === 'admin') {
          navigate('/dashboard');
        } else if (userType === 'agent') {
          navigate('/dashboardAgent');
        } else if (userType === 'subAgent') {
          navigate('/dashboardSubAgent');
        } 
        else if (userType === 'ambulance_company'){
          navigate('/dashboardForAmbulanceComapny')
        }
        else {
          navigate('/dashboard');
        }
      }
    } else {
      // Not authenticated: allow only public paths
      if (!publicPaths.has(location.pathname)) {
        navigate('/');
      }
    }
  }, [navigate, location]);

  return children;
}

export default AuthWrapper;
